import React from 'react';

export default function FeatureSearch( { searchPlaceholder, onChange } ) {
    return (
        <div className="flex justify-between items-center" style={{borderBottom: '1px solid #dddddd'}}>
            <input type="text" placeholder="Search..." onChange={onChange} className="text-md w-full p-2 text-gray-800 relative" />
            <i className="fas fa-search absolute right-0 pr-2"></i>
        </div>
    )
}